<template>
  <v-container style="max-width: 800px; min-width: 600px;">
    <table>
      <tbody>
        <tr>
          <td>
            <div id="con1">
              <span
                class="ct"
                style="display: inline; font-family: 微軟正黑體;"
              >
                <h1>取道台灣，逕登漢學堂奧</h1>
                <br />
                <p>
                  台灣，擁有五千年中華文化潤澤的人文底蘊，又地處亞太平洋區塊的樞紐位置，早已是｢國際漢學｣｢當代中國研究｣社群中關鍵的一環；台灣多元社會、海納百川的學術氛圍，更為世界各國探究華人文化與中國社會不可或缺的通路。｢臺灣學術經典｣期以台灣學人的觀點，整編華文區漢籍經典文獻，展現台灣優秀學術社群豐美成果，與全球漢學者共享。｢經典｣一詞最常用於｢人文學｣與｢社會科學｣的文獻中，故名為｢經典｣，即表明平台將聚焦於這兩大學科:
                  ｢人文學｣向為台灣歷史最悠久、最優美動人的風景；｢社會科學｣則蘊含認識華人世界與當代中國最深入透闢、最開放多元的獨特視角。｢小而美、小而力、質精且關鍵｣是本平台的特色:
                  匯集全台由國科會評選最核心的學刊之外，亦收錄獨家史料、檔案，及具研究價值、可雅俗共賞的雜誌經典(如雄獅美術、傳記文學等)，更挖掘默默耕耘、厚積有成的優質期刊，分別納於十二類學門中曖曖內含光，成為平台的獨門特色。
                </p>

                <br />

                <p>
                  本平台共計20億字，300餘刊，10萬餘篇論文，6630部文獻，3萬5千名作者，每ㄧ篇都能作全文檢索。
                </p>
              </span>
              <div
                class="en"
                style="word-break: normal; overflow-wrap: break-word; display: none; font-family: monospace;"
              >
                <h1>Go deep into Chinese Study via Taiwan</h1>

                <br />
                <p>
                  For the global sinology community, Taiwan has its
                  irreplaceable position and research value for Chinese
                  studies---not only for the Classical Chinese, but for the
                  Modern China as well. Inheriting the rich Chinese culture of
                  5000 years and colonial influence, Taiwan is always
                  multicultural and owns great tolerance for different opinions
                  and inclusive academic atmosphere, not to mention its superior
                  geographical location—in the heart of Asia-Pacific area, and
                  its historical dilemma with China that always affects the
                  international situation of politics and the global gaze.
                </p>

                <br />
                <p>
                  Based on Taiwanese scholars’ viewpoints, Taiwan Academic
                  Classics proudly offers classic works from China/Taiwan and
                  contemporary scholarly thought from academic societies in
                  Taiwan to sinologists around the World, uniting the classics
                  from Earth's oldest continuous civilization and unfettered
                  Chinese scholarly thought. Taiwan Academic Classics (TAC)
                  focuses on Humanities and Social Sciences, the former is
                  acclaimed as the most beautiful scenery of Taiwan, while the
                  latter represents the broadest outlook worldwide to go deep
                  into contemporary China and sinology. As a federated search
                  platform, TAC incorporates full text searchable Web access to
                  core journals from 1928 to the present with ancient
                  compilations from China's earliest Dynasties. Half the core
                  journals had been selected in the list of excellent journals,
                  THCI (Taiwan Humanities Citation Index) and TSSCI (Taiwan
                  Social Sciences Citation Index) evaluated by Research
                  Institute for the Humanities and Social Sciences, Ministry of
                  Science and Technology, the most creditable official
                  institution on ranking superior journals in Taiwan, while the
                  other half are exclusively authoritative archives, historical
                  data, and distinguished magazines that can be enjoyed by
                  scholars and lay-people alike (such as Zhuanji Wenxue
                  Magazine, Modern China Magazine, Lionart Magazine, etc.).
                </p>
                <br />
                <p>
                  Published by United Digital Publications Company Ltd., TAC
                  helps scholars explore new issues and historical trends,
                  especially on the plentiful, exclusive data and dissertations
                  of the era of the Chinese Republic. Meanwhile, Scholars
                  greatly appreciate the challenges of digitizing scholarly
                  titles such as Bulletin of the Institute of History and
                  Philology from Academia Sinica. TAC integrates a total of 2
                  billion characters, 300 different journals, 6,630 ancient
                  works and more than 100,000 dissertations, with contributions
                  from 35,000 authors.
                </p>
              </div>
              <!--a class="ct" target="_blank" style="color:blue" href="tac_DM.pdf">&nbsp;&nbsp;(型錄下載)</a>
                <a class="en" target="_blank" style="color:blue" href="tac_DM(Eng).pdf">&nbsp;&nbsp;(Flyer)</a-->
              <br />
              <div style="width:100%;height:20vh">
                <div style="width:50%;float:left">
                  <div class="aboutBtn" style="height:39px">
                    <h4>
                      <a
                        href="#"
                        onclick="ViewArea2('i1', 'intArea')"
                        class="PointBtn"
                        style="color:#111"
                        >&nbsp;&nbsp;█
                        <span
                          class="ct"
                          style="display: inline; font-family: 微軟正黑體;"
                          >(中研院)經典人文學刊庫</span
                        ><span
                          class="en"
                          style="overflow-wrap: break-word; word-break: normal; display: none; font-family: monospace;"
                          >SINICA Sinoweb</span
                        ><span
                          style="font-size: 10px; color: gray; display: inline;"
                          >&nbsp;(1928~<span
                            class="ct"
                            style="display: inline; font-family: 微軟正黑體;"
                            >今</span
                          ><span
                            class="en"
                            style="display: none; font-family: monospace;"
                            >present</span
                          >)</span
                        ></a
                      >
                    </h4>
                  </div>
                  <div class="aboutBtn" style="height:39px">
                    <h4>
                      <a
                        href="#"
                        onclick="ViewArea2('i2', 'intArea')"
                        class="PointBtn"
                        style="color:#111"
                        >&nbsp;&nbsp;█
                        <span
                          class="ct"
                          style="display: inline; font-family: 微軟正黑體;"
                          >臺灣人社百刊</span
                        ><span
                          class="en"
                          style="overflow-wrap: break-word; word-break: normal; display: none; font-family: monospace;"
                          >Taiwan Journals Search</span
                        ><span
                          style="font-size: 10px; color: gray; display: inline;"
                          >&nbsp;(1967~<span
                            class="ct"
                            style="display: inline; font-family: 微軟正黑體;"
                            >今</span
                          ><span
                            class="en"
                            style="display: none; font-family: monospace;"
                            >present</span
                          >)</span
                        ></a
                      >
                    </h4>
                  </div>
                  <div class="aboutBtn" style="height:39px">
                    <h4>
                      <a
                        href="#"
                        onclick="ViewArea2('i3', 'intArea')"
                        class="PointBtn"
                        style="color:#111"
                        >&nbsp;&nbsp;█
                        <span
                          class="ct"
                          style="display: inline; font-family: 微軟正黑體;"
                          >傳記文學全文資料庫</span
                        ><span
                          class="en"
                          style="overflow-wrap: break-word; word-break: normal; display: none; font-family: monospace;"
                          >Zhuanji Wenxue Digital Archives</span
                        ><span
                          style="font-size: 10px; color: gray; display: inline;"
                          >&nbsp;(1962~<span
                            class="ct"
                            style="display: inline; font-family: 微軟正黑體;"
                            >今</span
                          ><span
                            class="en"
                            style="display: none; font-family: monospace;"
                            >present</span
                          >)</span
                        ></a
                      >
                    </h4>
                  </div>
                  <div class="aboutBtn" style="height:39px">
                    <h4>
                      <a
                        href="#"
                        onclick="ViewArea2('i4', 'intArea')"
                        class="PointBtn"
                        style="color:#111"
                        >&nbsp;&nbsp;█
                        <span
                          class="ct"
                          style="display: inline; font-family: 微軟正黑體;"
                          >近代中國全文資料庫</span
                        ><span
                          class="en"
                          style="overflow-wrap: break-word; word-break: normal; display: none; font-family: monospace;"
                          >Modern China full text Database</span
                        ><span
                          style="font-size: 10px; color: gray; display: inline;"
                          >&nbsp;(1977~2005)</span
                        ></a
                      >
                    </h4>
                  </div>
                </div>
                <div style="width:50%;float:left">
                  <div class="aboutBtn">
                    <h4>
                      <a
                        href="#"
                        onclick="ViewArea2('i5', 'intArea')"
                        class="PointBtn"
                        style="color:#111"
                        >█
                        <span
                          class="ct"
                          style="display: inline; font-family: 微軟正黑體;"
                          >臺灣文獻叢刊</span
                        ><span
                          class="en"
                          style="overflow-wrap: break-word; word-break: normal; display: none; font-family: monospace;"
                          >Taiwan Wenxian Congkan</span
                        ><span
                          style="font-size: 10px; color: gray; display: inline;"
                          >&nbsp;<span
                            class="ct"
                            style="display: inline; font-family: 微軟正黑體;"
                            >(唐宋元明清~1963年)</span
                          ><span
                            class="en"
                            style="display: none; font-family: monospace;"
                            >(Tang Dynasty-Qing Dynasty)</span
                          ></span
                        ></a
                      >
                    </h4>
                  </div>
                  <div class="aboutBtn">
                    <h4>
                      <a
                        href="#"
                        onclick="ViewArea2('i6', 'intArea')"
                        class="PointBtn"
                        style="color:#111"
                        >█
                        <span
                          class="ct"
                          style="display: inline; font-family: 微軟正黑體;"
                          >臺灣文獻叢刊續編</span
                        ><span
                          class="en"
                          style="overflow-wrap: break-word; word-break: normal; display: none; font-family: monospace;"
                          >Taiwan Wenxian Congkan: Continuation</span
                        ><span
                          style="font-size: 10px; color: gray; display: inline;"
                          >&nbsp;<span
                            class="ct"
                            style="display: inline; font-family: 微軟正黑體;"
                            >(明清/日治時期~1958年)</span
                          ><span
                            class="en"
                            style="display: none; font-family: monospace;"
                            >(Ming Dynasty-1958)</span
                          ></span
                        ></a
                      >
                    </h4>
                  </div>
                  <div class="aboutBtn">
                    <h4>
                      <a
                        href="#"
                        onclick="ViewArea2('i7', 'intArea')"
                        class="PointBtn"
                        style="color:#111"
                        >█
                        <span
                          class="ct"
                          style="display: inline; font-family: 微軟正黑體;"
                          >標點古今圖書集成</span
                        ><span
                          class="en"
                          style="overflow-wrap: break-word; word-break: normal; display: none; font-family: monospace;"
                          >Biaodian Gujin Tushu Jicheng</span
                        ><span
                          style="font-size: 10px; color: gray; display: inline;"
                          >&nbsp;<span
                            class="ct"
                            style="display: inline; font-family: 微軟正黑體;"
                            >(上古~清初)</span
                          ><span
                            class="en"
                            style="display: none; font-family: monospace;"
                          >
                            (Xia Dynasty-Qing Dynasty)</span
                          ></span
                        ></a
                      >
                    </h4>
                  </div>
                  <div class="aboutBtn">
                    <h4>
                      <a
                        href="#"
                        onclick="ViewArea2('i9', 'intArea')"
                        class="PointBtn"
                        style="color:#111"
                        >█
                        <span
                          class="ct"
                          style="display: inline; font-family: 微軟正黑體;"
                          >雄獅美術知識庫</span
                        ><span
                          class="en"
                          style="overflow-wrap: break-word; word-break: normal; display: none; font-family: monospace;"
                          >Lionart Digital Archive</span
                        ><span
                          style="font-size: 10px; color: gray; display: inline;"
                          >&nbsp;(1971~1996)</span
                        ></a
                      >
                    </h4>
                  </div>
                  <div class="aboutBtn">
                    <h4>
                      <a
                        href="#"
                        onclick="ViewArea2('i8', 'intArea')"
                        class="PointBtn"
                        style="color:#111"
                        >█
                        <span
                          class="ct"
                          style="display: inline; font-family: 微軟正黑體;"
                          >歷代書法碑帖集成</span
                        ><span
                          class="en"
                          style="overflow-wrap: break-word; word-break: normal; display: none; font-family: monospace;"
                        >
                          Chinese Calligraphy and Inscription Collection</span
                        ><span
                          style="font-size: 10px; color: gray; display: inline;"
                          >&nbsp;<span
                            class="ct"
                            style="display: inline; font-family: 微軟正黑體;"
                            >(上古~清末)</span
                          ><span
                            class="en"
                            style="display: none; font-family: monospace;"
                          >
                            (Xia Dynasty-Qing Dynasty)</span
                          ></span
                        ></a
                      >
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <br />
            <div id="i1" class="con_r_c intArea" style="display:none">
              <div style="width:70%">
                <a
                  href="#"
                  onclick="Expansion5('#i1')"
                  class="close-button"
                  style="float:right"
                ></a>
              </div>
              <div style="width:100%" class="clear">
                <p class="infotitle">
                  █ (中研院)經典人文學刊庫 Sinica Sinoweb&nbsp;<span
                    class="infotime"
                    >(1928~<span
                      class="ct"
                      style="display: inline; font-family: 微軟正黑體;"
                      >今</span
                    ><span
                      class="en"
                      style="display: none; font-family: monospace;"
                      >present</span
                    >)</span
                  >
                </p>
              </div>
              <br />
              <br />
              <div style="width:100%;height:55vh;overflow:visible;">
                <h2>
                  收錄「中央研究院」史語所、文哲所、近史所、民族所、臺史所等核心漢學期刊，及臺灣頂尖經典人文學刊:《漢學研究》《思與言》《食貨》及《鵝湖》等14刊，完整回溯至創刊號，是全球唯一完整無缺，且獨家提供早期內文100%精確檢索功能的資料庫，尤以「歷史語言研究所集刊」「漢學研究」等高難度早期過刊的完整內文重打，關鍵詞標示至段落，便利學人作內文精確搜尋與深度研究，令國際漢學界驚艷，為獨門特色。
                </h2>
                <h2>
                  As the sole full text searchable database of its kind from
                  Taiwan, Sinica Sinoweb (SSW) collects the core sinological
                  journals of Academia Sinica, and other outstanding Taiwanese
                  journals known worldwide. The content and issues of SSW are
                  100% complete. The full text search and the search efficiency
                  is 100% exact. From the first issue to the present, the
                  collection is intact and exclusively available for full text
                  search. Sinologists from around the world have highly praised
                  and appreciated the excellent digitization work on difficult
                  early titles, such as, Bulletin of the Institute of History
                  and Philology, and Chinese Studies.
                </h2>
                <a target="_blank" href="sino.pdf" style="color:blue"
                  >目錄下載 (Title list)</a
                >
              </div>
            </div>
            <div id="i2" class="con_r_c intArea" style="display:none">
              <div style="width:70%">
                <a
                  href="#"
                  onclick="Expansion5('#i2')"
                  class="close-button"
                  style="float:right"
                ></a>
              </div>
              <div style="width:100%" class="clear">
                <p class="infotitle">
                  █臺灣人社百刊 Taiwan Journals Search&nbsp;<span
                    class="infotime"
                    >(1967~<span
                      class="ct"
                      style="display: inline; font-family: 微軟正黑體;"
                      >今</span
                    ><span
                      class="en"
                      style="display: none; font-family: monospace;"
                      >present</span
                    >)</span
                  >
                </p>
              </div>
              <br />
              <br />
              <div style="width:100%;height:55vh;overflow:visible;">
                <h2>
                  囊括全臺灣核心學刊的絕大部分 :
                  ｢人文社科｣領域之優質期刊310刊以上， 其中120刊以上為THCI /
                  TSSCI核心學刊，其餘則發掘厚積有成、曖曖內含光的優質期刊，分納於20門學科中，成為平台獨門特色，其中｢藝術設計類｣32刊中有多刊屬獨特刊。本庫可與「中研院人文庫」｢傳記文學｣等整合搜尋，以「內文精確檢索」特色切中學術需求，尤其文史哲藝類別，多數刊都回溯至創刊號，每一篇內文都能快速且精準地查詢，並按相關性排序，自動過濾掉無關資訊。本庫橫跨的20種學科是：歷史、文哲、藝術、設計、考古、人類學、宗教、語言、區域研究、地理、社會、文化、傳播、法律、政治、國關、管理、經濟、教育、心理、人社綜合等，持續更新中。
                </h2>
                <h2>
                  “Taiwan Journals Search”(臺灣人社百刊) collected 310+
                  Taiwanese core/notable journals in humanities and social
                  sciences, covering most of Taiwanese high-quality journals in
                  that field. Among those, more than 120 titles had been elected
                  in the most credible journal-appraisal system－the Taiwan
                  Humanities Citation Index (THCI), and the Taiwan Social
                  Sciences Citation Index (TSSCI), while the other unique,
                  notable titles are famed for their long-term cultivation and
                  amazing achievement. Integrating 20 subjects/disciplines:
                  history, anthropology, literature, philosophy, art, design,
                  religion, linguistics, philology, regional study, geography,
                  sociology, culture, communications, laws, politics,
                  international relation, management, economics, education,
                  psychology and syntheses, TJS features its unique journals of
                  art/design/humanities on content, and its research
                  topics/historical trend analysis on search functions as well.
                  TJS excludes non-academic periodicals, focusing on only the
                  best academic journals from Taiwan. It is purely
                  scholar-oriented, able to meet researchers demands precisely,
                  and can be called“the greatest collection of Chinese
                  studies/Sinology from the Taiwanese perspective.”
                </h2>
                <a target="_blank" href="tjs.pdf" style="color:blue"
                  >目錄下載 (Title list)</a
                >
              </div>
            </div>
            <div id="i3" class="con_r_c intArea" style="display:none">
              <div style="width:70%">
                <a
                  href="#"
                  onclick="Expansion5('#i3')"
                  class="close-button"
                  style="float:right"
                ></a>
              </div>
              <div style="width:100%" class="clear">
                <p class="infotitle">
                  █傳記文學全文資料庫 Zhuanji Wenxue Digital Archive&nbsp;<span
                    class="infotime"
                    >(1962~<span
                      class="ct"
                      style="display: inline; font-family: 微軟正黑體;"
                      >今</span
                    ><span
                      class="en"
                      style="display: none; font-family: monospace;"
                      >present</span
                    >)</span
                  >
                </p>
              </div>
              <br />
              <br />
              <div style="width:100%;height:55vh;overflow:visible;">
                <h2>
                  收錄自創刊迄今達58年，近700期原始版面與全文檢索完整無缺，累積豐富的中國
                  現代史料，素有「民國史長城」美譽，重要性與官修國史鼎足而立。以「口述
                  歷史」見長，除刊載現代中國許多軍政領袖、達官顯要之事蹟，同時也為學者
                  專家、社會名流、幫會頭目、名伶藝人，及被正史忽略的市井小民作傳。本庫
                  滿足當代大眾對重探民國風華的期待，也提供學者專家大量的一手研究素材，
                  既是民國史論文必備引用之史料庫，亦可雅俗共賞。
                </h2>
                <h2>
                  Over the past 58 years, Zhuanji Wenxue Magazine
                  (傳記文學1962-present) has become world renowned. Like the
                  Great Wall itself, Zhuanji Wenxue has become a long and
                  formidable historical record, drawing comparisons as the “The
                  Great Wall of Chinese Republican History.” Being ranked at the
                  same academic position with heavyweight, national research
                  institutions of modern history, it is rated as the paragon of
                  unofficial historical data, and an excellent, unique
                  supplement to authoritative history in China and Taiwan
                  covering the past 2000 years. For example, the top 3 research
                  institutions in Taiwan in the study of Dr. Sun Yat Sen (Father
                  of R.O.C.) and the history of the Chinese revolution are the
                  Kuomintang Party History Commission, the Modern History
                  Institute of Academia Sinica, and Zhuanji Wenxue Magazine. In
                  terms of content quality, Zhuanji Wenxue is regarded as equal
                  to those two most important academic institutions in Taiwan.
                  Zhuanji Wenxue helps historians to find clues to difficult
                  historical problems, and puts the flesh back onto the skeleton
                  of official history. It treats various people’s narrations as
                  historical data. Biographies are not only of political and
                  military leaders, prominent officials and eminent personages,
                  but also of famous scholars, social celebrities, chiefs of
                  secret societies, spies, renowned actors and actresses and
                  common people alike. Zhuanji Wenxue helps to fill gaps in
                  official history. As an essential historic-material database
                  of more than 130 million characters and the core reference of
                  dissertations on Chinese Republic history in the past 40
                  years, it includes autobiography, critical biography, memoir,
                  exclusive historical data, diary entries, handwriting samples,
                  oral history, and more. Readers will praise this extensive
                  record and its ability to bring history to life.
                </h2>
              </div>
            </div>
            <div id="i4" class="con_r_c intArea" style="display:none">
              <div style="width:70%">
                <a
                  href="#"
                  onclick="Expansion5('#i4')"
                  class="close-button"
                  style="float:right"
                ></a>
              </div>
              <div style="width:100%" class="clear">
                <p class="infotitle">
                  █ 近代中國全文資料庫 Modern China Database&nbsp;<span
                    class="infotime"
                    >(1977~2005)</span
                  >
                </p>
              </div>
              <br />
              <br />
              <div style="width:100%;height:55vh;overflow:visible;">
                <h2>
                  收錄創刊至絕刊完整內容。本刊由「中國國民黨黨史會」創辦，向以大量豐富
                  的民國史、革命文獻、先烈人物檔案著稱。一般歷史學刊多以「論著評述」為
                  主，「近代中國」卻能以其豐富庫藏，連續披露國民黨一手權威史料，發表民
                  國史當事人憶述資料，同時結合獨家檔案與歷史研究，為其難得之特色。她也
                  是「口述歷史」之佼佼者，並常舉辦「國際學術研討會」，作者遍及中日韓老
                  中青三代，絕非國民黨一家之言。而許多精心策畫的「台灣」專輯，也都是經
                  典之作。
                </h2>
                <h2>
                  Founded by the Chinese Kuomintang, Modern China Magazine
                  (which ran from March 1977 until December 2005) is renowned
                  for its coverage of Chinese Republican history, archives of
                  Revolutionary Martyrs and Revolutionary documents of China.
                  While other historic academic journals of its kind regard
                  discourse and comment as important, Modern China peerlessly
                  exposes first-hand authoritative historic materials of the
                  Kuomintang, revealing the “oral history” in the Republican
                  period, and combining exclusive archives and historic
                  research. Including 4,902 articles, 163 issues, 48,200
                  figures, 38,000 institutions and historical events in its 29
                  year run, Modern China frequently sponsored and hosted
                  international academic seminars. Members and contributors came
                  from Mainland China, Korea, Japan, Hong Kong as well as
                  Taiwan.
                </h2>
              </div>
            </div>
            <div id="i5" class="con_r_c intArea" style="display:none">
              <div style="width:70%">
                <a
                  href="#"
                  onclick="Expansion5('#i5')"
                  class="close-button"
                  style="float:right"
                ></a>
              </div>
              <div style="width:100%" class="clear">
                <p class="infotitle">
                  █ 臺灣文獻叢刊 Taiwan Wenxian Congkan&nbsp;<span
                    class="infotime"
                    ><span
                      class="ct"
                      style="display: inline; font-family: 微軟正黑體;"
                      >(唐宋元明清~1963年)</span
                    ><span
                      class="en"
                      style="display: none; font-family: monospace;"
                      >(Tang Dynasty-Qing Dynasty)</span
                    ></span
                  >
                </p>
              </div>
              <br />
              <br />
              <div style="width:100%;height:55vh;overflow:visible;">
                <h2>
                  坊間相同取材中，唯一的全文圖像數位版，是史學界公認現今收錄最齊全、最
                  權威的臺灣史料全記錄，也是研究者查閱最頻繁的典籍之一，更是鄉土教學、
                  臺灣文化之最佳代表。素有「臺灣百科全書」之稱，包含臺灣方志、明鄭史料
                  、清代檔案等309種臺灣史籍，4800餘萬字，上自唐宋元明之文，下至日據時期
                  臺灣當地人士之作，以貼近臺灣史的觀點，記錄詮釋臺灣各地區的開發史、城
                  市演變、人物事蹟、風土民情、詩文傳承等。
                </h2>
                <h2>
                  One of the most frequently used works by scholars of Taiwan
                  studies and commonly called the “Encyclopedia of Taiwan,” the
                  Taiwan Wenxian Congkan (ed. Hsien-Wen Chou) was originally
                  published by the Bank of Taiwan. Taiwan Wenxian Congkan is
                  comprised of 309 books and incorporates local histories and
                  official documents of the Ming and Qing dynasties, including
                  the short-lived Southern Ming. Includes poems, works from
                  private collections (some of which are only remaining copy),
                  and out-of-print books. Also covers topics from the Tang
                  Dynasty to the Japanese occupation period in documents
                  gathered from local and overseas libraries. From the Taiwanese
                  perspective, Taiwan Wenxian Congkan records a variety of
                  dimensions of Taiwan, including the historical development of
                  individual districts, the evolution of cities, deeds of
                  individual people, local customs and culture. It is indeed the
                  largest collection on the history of Taiwan in the Chinese
                  language. United Digital Publications Company Ltd. is pleased
                  to exclusively offer the only full text and full-image version
                  of Taiwan Wenxian Congkan as e-content.
                </h2>
                <a
                  target="_blank"
                  href="台灣文獻叢刊書目309種.pdf"
                  style="color:blue"
                  >書目下載 (Title list)</a
                >
              </div>
            </div>
            <div id="i6" class="con_r_c intArea" style="display:none">
              <div style="width:70%">
                <a
                  href="#"
                  onclick="Expansion5('#i6')"
                  class="close-button"
                  style="float:right"
                ></a>
              </div>
              <div style="width:100%" class="clear">
                <p class="infotitle">
                  █ 臺灣文獻叢刊續編 Taiwan Wenxian Congkan:
                  Continuation&nbsp;<span class="infotime"
                    ><span
                      class="ct"
                      style="display: inline; font-family: 微軟正黑體;"
                      >(明清/日治時期~1958年)</span
                    ><span
                      class="en"
                      style="display: none; font-family: monospace;"
                      >(Tang Dynasty-1958)</span
                    ></span
                  >
                </p>
              </div>
              <br />
              <br />
              <div style="width:100%;height:55vh;overflow:visible;">
                <h2>
                  本庫廣羅《臺灣文獻叢刊》遺珠，收錄海峽兩岸204種已絕版或將絕版之經典文
                  獻，首度以「全文圖像版」樣貌問世。包括八大類：閩臺方志／輿圖／經濟史
                  （22種）、閩臺風物／雜記（19種）、「閩臺詩文（70種）、日治政府／二二
                  八／白色恐怖（16種）、明清閩臺事變（16種）、明清海防／倭變／窺臺戰事
                  （22種）、清鄭對峙／南明史料（23種）、清領閩臺政事（16種）。
                </h2>
                <h2>
                  The Taiwan Wenxian Congkan Continuation database updates one
                  of the most important resources in Taiwan studies. Coverage in
                  the original Taiwan Wenxian Congkan was limited to the
                  1958-1972 period, and subsequently new historical records were
                  uncovered. Accordingly, United Digital Publications Company
                  Ltd. has compiled the Taiwan Wenxian Congkan Continuation
                  database, which includes additional books, archives and
                  literature gathered since the original edition was released by
                  the Bank of Taiwan. One half of these materials consist of
                  books and the only extant copies of manuscripts and
                  handwritings emanating from prestigious universities in China.
                  The other half of the records originated from research
                  institutions and publishers in Taiwan. Content included in the
                  earlier publication is excluded, except in cases where a newer
                  edition adds value. The Taiwan Wenxian Congkan Continuation
                  database is full text and full-image, with textual criticism,
                  original sources and author introductions in 204 books
                  covering chorography, geographic accounts, local customs,
                  poems, literature, political archives, official documents,
                  civil affairs, war records, records of coastal defenses, the
                  actions of Japanese pirates, the ‘228 Incident,’ the face-off
                  between Zheng Cheng-Gong and the Manchu court, and historical
                  records of the Southern Ming Dynasty.
                </h2>
                <a
                  target="_blank"
                  href="台灣文獻叢刊續編書目204種.pdf"
                  style="color:blue"
                  >書目下載 (Title list)</a
                >
              </div>
            </div>
            <div id="i7" class="con_r_c intArea" style="display:none">
              <div style="width:70%">
                <a
                  href="#"
                  onclick="Expansion5('#i7')"
                  class="close-button"
                  style="float:right"
                ></a>
              </div>
              <div style="width:100%" class="clear">
                <p class="infotitle">
                  █標點古今圖書集成 Biaodian Gujin Tushu Jicheng&nbsp;<span
                    class="infotime"
                    ><span
                      class="ct"
                      style="display: inline; font-family: 微軟正黑體;"
                      >(上古~清初)</span
                    ><span
                      class="en"
                      style="display: none; font-family: monospace;"
                    >
                      (Xia Dynasty-Qing Dynasty)</span
                    ></span
                  >
                </p>
              </div>
              <br />
              <br />
              <div style="width:100%;height:55vh;overflow:visible;">
                <h2>
                  全世界最大的百科全書，與｢四庫全書｣並稱為｢中國類書整理中的雙璧｣。本資料庫是全球第一個標點數位版，介面簡明，搜尋精準快速，檢索詞標示至段落，並有全文與原版對照，全文檔能複製引用，甚為便利，亦無繁冗功能減低搜尋正確度與效能，推出以來在國際漢學界頗受好評，已有百餘所知名漢學研究機構採購
                  (包括:
                  哈佛大學、耶魯大學、劍橋大學、牛津大學、雪梨大學、萊登大學、新加坡國立大學等)，是全球機構訂戶最多的版本之一。
                </h2>
                <h2>
                  Gujin Tushu Jicheng is the greatest encyclopedia of Chinese
                  civilization, and one of the most significant two classified
                  books of ancient China as well. (The other one is Xiku
                  Quanshu. Both of them are regarded as the most brilliant two
                  pearls of China classified/reference books! ) Now, its
                  database Biaodian Gujin Tushu Jicheng (標點古今圖書集成) had
                  been published by UDP from Taiwan. The database is not only
                  the first punctuated version of its kind, but also one of the
                  most popular digital version worldwide. It features full text
                  and full-image content, a clear and concise interface, a fast
                  and precise search, and all search words are highlighted in
                  the text. More than 100 institutions and famous universities
                  around the world subscribe to the database.
                </h2>
                <a target="_blank" href="cbs_index.pdf" style="color:blue"
                  >目錄下載 (Title list)</a
                >
              </div>
            </div>
            <div id="i8" class="con_r_c intArea" style="display:none">
              <div style="width:70%">
                <a
                  href="#"
                  onclick="Expansion5('#i8')"
                  class="close-button"
                  style="float:right"
                ></a>
              </div>
              <div style="width:100%" class="clear">
                <p class="infotitle">
                  █歷代書法碑帖集成 Chinese Calligraphy and Inscription
                  Collection<span
                    class="ct"
                    style="display: inline; font-family: 微軟正黑體;"
                    >(殷商~清末)</span
                  ><span
                    class="en"
                    style="display: none; font-family: monospace;"
                  >
                    (Shang Dynasty-Qing Dynasty)</span
                  >
                </p>
              </div>
              <br />
              <br />
              <div style="width:100%;height:55vh;overflow:visible;">
                <h2>
                  ｢書法」蘊含最多中國文化元素，是華夏民族藝術的核心，無人生活中離得開文字美學，其影響力甚至遠及西方藝術。本資料庫共收錄4,268部經典碑帖，700書家，170萬個字形與釋文，是整合「原版全帖」｢單一圖字｣與「釋文搜尋」三大內容之大型書法資料庫，採Unicode錄字，在異體字典內有的古字亦能檢索到，是本庫特色。賞析、應用之外，亦兼具教學、研究、考據功能，曾獲2006年台灣新聞局「數位出版創新獎」。分成「全帖庫」「單字庫」兩子庫，「全帖庫」可依釋文、碑帖、作者、朝代、原藏地等欄位作全文檢索，及作不同朝代、作者、碑帖間書風之比較賞析，享受｢風流餘韻，上友古人｣的中國文字之美；「單字庫」每一圖字皆保留原來神韻，翰墨神品如見原跡，可作文件標題、名片、招牌、廣告美編等運用，隨手即將｢中國字的藝術｣融入日常生活之中。
                </h2>
                <h2>
                  Containing maximum elements of Chinese culture, calligraphy is
                  generally regarded as the core of Chinese art. To discuss
                  Chinese art without calligraphy knowledge is nearly
                  impossible. Even calligraphy influences the Western art. For
                  example, the ink and wash paintings from many renowned artists
                  must be judged in view of calligraphy, otherwise, all the
                  comments on them will be meaningless. Plus, Chinese characters
                  possess high practicability, everybody must use characters in
                  his daily life. The database collects 4268 significant,
                  classical works of calligraphy/inscriptions and 1.7 million
                  characters in various forms, integrating single-character
                  photos, full-work images with full-text search engine, and
                  featuring its unique search efficiency on ancient characters’
                  variants contained in the “Dictionary of Chinese Character
                  Variants” by Ministry of Education in Taiwan.
                  Philology/textual research, education, appreciation and
                  practice are its main functions. It divided into 2
                  sub-databases: “Full Work Database”, in which users can
                  promptly find different calligraphers' works from different
                  dynasties, compare their styles, and enjoy the glamorous
                  Chinese characters via search engine. “Single Character
                  Database”, in which every character photo reserves its
                  original looks, charm and feeling. Users can apply
                  conveniently the character photos to document/briefing
                  heading, name card, signboard, advertisement design while
                  blending Chinese art into their daily lives.
                </h2>
              </div>
            </div>
            <div id="i9" class="con_r_c intArea" style="display:none">
              <div style="width:70%">
                <a
                  href="#"
                  onclick="Expansion5('#i9')"
                  class="close-button"
                  style="float:right"
                ></a>
              </div>
              <div style="width:100%" class="clear">
                <p class="infotitle">
                  █雄獅美術知識庫 Lionart Digital Archive&nbsp;<span
                    class="infotime"
                    >(1971~1996)</span
                  >
                </p>
              </div>
              <br />
              <br />
              <div style="width:100%;height:55vh;overflow:visible;">
                <h2>
                  「雄獅美術月刊」曾是1971-1996年間活躍於臺灣最有影響力的藝術期刊，也是許多海內外藝術人爭相投稿的平臺，記錄四分之一世紀臺灣藝術發展的軌跡，收錄的4,000位藝術家懷舊作品、一萬頁絕版畫廊廣告、藝評藝作及藝術家專輯等，皆為獨家史料。雄獅發刊宗旨是:
                  ｢引介西方思潮，發掘本土藝術，為中國美術與民族文藝造像｣，既有西方大師級特展，亦能發掘本土新秀、素人藝術家，尤其企劃｢台灣前輩美術家｣｢台灣當代書畫家｣等招牌專輯，更是｢發人所未發，見人所未見｣，不僅為後世保存獨家史料，更是啟發觀念、樹立藝壇典範之創舉，影響深遠，雄獅文教事業體至今仍是台灣藝術出版界的第一品牌。此庫另有專業藝術辭庫加值:
                  雄獅長銷出版品《中國美術辭典》、《西洋美術辭典》及《臺灣美術年鑑》共12,220則辭條，30,000篇佳文，68,000頁圖檔，搭配雄獅招牌內容，是藝術賞析與藝術教育的最佳參考庫之一。
                </h2>
                <h2>
                  In late 20th century, Lionart Monthly was the most
                  sought-after platform where many artists, critics, and
                  intellectuals were enthusiastic to share their opinions
                  through arts. This leading art magazine not only well
                  documented people’s thought and reactions during and after the
                  period of martial law (1949-1987), but it also had nurtured
                  many art masters and influential figures in the fields of art
                  and humanity in Greater China for 1/4 century. The aim of
                  Lionart Monthly was to enrich the Chinese arts field by
                  introducing the avant-garde thoughts from the Western world
                  and supporting the emerging artists from Taiwan. It was
                  diverse and significant in the history, and the best
                  first-hand material to investigate the fields of Asian arts,
                  humanity, and the turbulent history of Cross-Strait relations
                  in 20th century as well. Lionart Publications Enterprise has
                  been the dominant brand of the art publishing industry in
                  Taiwan since 1971. And its prestigious publications still have
                  great influence in the field of Taiwanese arts and cultures to
                  date. Lionart Digital Archive ever won the visual art funding
                  provided by Taiwan's Ministry of Culture. It collects 307
                  issues, 44 million characters, 30000 articles, 68000 pictures,
                  10000 pages of rare, nostalgic advertisement, and 12220
                  vocabulary entries. Most of them are exclusive historical
                  documentaries on art developments in Taiwan.
                </h2>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </v-container>
</template>
<script>
export default {
  mounted() {
    this.$store.commit('set_mainset')
  },
}
</script>
